import QuestionInputSelect from "./QuestionInputSelect";

export default class QuestionInputSelectMultiEquivalents extends QuestionInputSelect {
	constructor(question, view) {
		super(question, view);
		this._view.signals.slotChosen.add(this.onSlotChosen, this);
		this._selections = [];
	}

	selectOption(option) {
		this._selected = option;
		this._selected.alpha = 0.5;
		if (this._selections.indexOf(this._selected) === -1) {
			this._selections.push(this._selected);
		}
	}

	onSlotChosen(ndx, inputNdx) {
		if (inputNdx > -1) {
			const previousSelected = this._selections[inputNdx];
			previousSelected.tint = 0xffffff;
			previousSelected.alpha = 1;
			previousSelected.enabled = true;
		}
		if (this._selected) {
			this._view.setAnswer(this._selected.value, ndx, this._selections.indexOf(this._selected));

			this._selected.tint = 0xff0000;
			this._selected.alpha = 0.25;
			this._selected.enabled = false;
			this._selected = null;
		} else {
			this._view.setAnswer(null, ndx, -1);
		}
	}
}